import { useNavigate } from 'react-router-dom';
import { css, useTheme } from '@emotion/react';
import { HelmetHead, MypageList } from '~/components/common';
import { PAGE_ROUTE } from '~/constants';

export default function Settings() {
  const theme = useTheme();
  const navigate = useNavigate();
  const settingsArr = [
    {
      id: 'settings_menu_01',
      menuName: 'Account',
      rightInfo: 'arrow',
      onClick: () => navigate(PAGE_ROUTE.ACCOUNT),
    },
    {
      id: 'settings_menu_02',
      menuName: 'Terms of service',
      rightInfo: 'arrow',
      onClick: () => navigate(PAGE_ROUTE.TERMS_OF_SERVICE),
    },
    {
      id: 'settings_menu_03',
      menuName: 'Privacy Policy',
      rightInfo: 'arrow',
      onClick: () => navigate(PAGE_ROUTE.PRIVACY_POLICY),
    },
  ];

  return (
    <>
      <HelmetHead title='Settings' />

      <div
        css={css`
          display: block;
          padding: ${theme.layout.chat_header_height} 16px
            ${theme.layout.chat_navigation_height};

          & > div {
            margin: 20px 0 30px;
          }
        `}
      >
        <div>
          <MypageList arr={settingsArr} />
        </div>
      </div>
    </>
  );
}
